import Vue from 'vue'
import mutations from './mutations'
import invoices from '@/api/invoices'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'
import AWN from 'awesome-notifications'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    najdiSteviloRacunov ({ commit }, electronicDeviceId) {
      return new Promise((resolve, reject) => {
        invoices.najdiSteviloRacunov(electronicDeviceId)
          .then((resp) => {
            const dobljeniRacuni = arrayToObject(resp.data.items)
            commit('setElements', { type: 'items', elements: dobljeniRacuni })
            resolve(dobljeniRacuni)
          })
          .catch((err) => reject(err))
      })
    },
    loadItems ({ commit }, { businessUnitId, childCompanyId, electronicDeviceId, number, dateFrom, dateTo, onlyClients, paymentType }) {
      return new Promise((resolve, reject) => {
        commit('setElements', { type: 'items', elements: {} })
        let findInvoiceEndpoint = null
        if (electronicDeviceId) findInvoiceEndpoint = invoices.findForDevice({ childCompanyId, electronicDeviceId, number, dateFrom, dateTo, paymentType })
        else {
          findInvoiceEndpoint = invoices.findForBusinessUnit({ businessUnitId, dateFrom, dateTo, onlyClients, paymentType })
        }
        findInvoiceEndpoint
          .then(response => {
            const invoices = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: invoices })
            resolve(invoices)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadItemsWithClients ({ commit, dispatch, state }, { businessUnitId, childCompanyId, electronicDeviceId, number, dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        commit('setElements', { type: 'items', elements: {} })
        let findInvoiceEndpoint = null
        if (electronicDeviceId) findInvoiceEndpoint = invoices.findForDevice({ childCompanyId, electronicDeviceId, number, dateFrom, dateTo })
        else {
          findInvoiceEndpoint = invoices.findForBusinessUnit({ businessUnitId, dateFrom, dateTo })
        }
        findInvoiceEndpoint
          .then(response => {
            const invoices = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: invoices })
            // resolve(items)
            const addInvoiceJobs = []
            Object.values(invoices).forEach(invoice => {
              if (invoice.client) {
                const addClientAction = dispatch('companies/getClient', { clientId: invoice.client, invoiceId: invoice.id }, { root: true })
                  .then(client => {
                    commit('addBuyerInfoToInvoice', { invoiceId: invoice.id, client })
                  })
                addInvoiceJobs.push(addClientAction)
              }
            })
            Promise.all(addInvoiceJobs)
              .then(response => resolve(state.items))
              .catch(error => reject(error))
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    saveItem ({ commit }, { electronicDeviceId, apiData }) {
      return new Promise((resolve, reject) => {
        const saveAction = []
        if (apiData.isReverseInvoice) {
          saveAction.push(
            invoices.reverseInvoice({ invoiceId: apiData.invoiceId, data: apiData })
          )
        } else {
          saveAction.push(
            invoices.save({ electronicDeviceId, data: apiData })
          )
        }
        Promise.all(saveAction)
          .then(response => {
            const receiptData = { ...apiData, ...response[0].data.items[0] }
            resolve(receiptData)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    createMissingInvoice ({ commit, state }, { number, year, electronicDeviceId }) {
      return new Promise((resolve, reject) => {
        const data = {
          number,
          year
        }
        // console.log(electronicDeviceId, data)
        invoices.createMissingInvoice({ electronicDeviceId, data })
          .then(() => {
            resolve()
          })
      })
    },
    updateItem ({ commit, state, rootState }, { invoiceId, updates, payments, comment, issuer }) {
      return new Promise((resolve, reject) => {
        const data = dataForApi(rootState.auth.userId, updates, payments, comment, issuer)
        invoices.update({ invoiceId, data })
          .then(response => {
            const newInvoiceId = response.data.items[0].invoice_id
            if (newInvoiceId) {
              updates.invoice_id = newInvoiceId
            }
            if (payments) {
              updates.payments = payments
            }
            if (comment !== null) {
              updates.comment = comment
            }
            commit('updateInvoice', { invoiceId, updates })
            resolve(state.items[invoiceId])
          })
          .catch(error => reject(error))
      })
    },
    addBuyerInfo ({ commit, dispatch }, buyer) {
      return new Promise((resolve, reject) => {
        dispatch('companies/addClient', buyer, { root: true })
          .then(buyerId => {
            buyer.id = buyerId
            resolve(buyer)
          })
          .catch(error => reject(error))
      })
    },
    setPrints ({ commit }, invoice) {
      return new Promise((resolve, reject) => {
        const data = {
          prints: [{
            index: invoice.printNumber,
            date: new Date()
          }]
        // prints: invoice.prints
        }
        invoices.setPrints({ id: invoice.id, data })
          .then(response => {
            commit('setInvoicePrints', invoice)
            resolve({})
          })
          .catch(error => reject(error))
      })
    },
    getPrints ({ commit }, invoice) {
      return new Promise((resolve, reject) => {
        invoices.getPrints({ id: invoice.id })
          .then(response => {
            const prints = response.data.items
            resolve(prints)
          })
          .catch(error => reject(error))
      })
    },
    cancelInvoice ({ dispatch, rootState }, { oldInvoice, comment }) {
      return new Promise((resolve, reject) => {
        const userId = rootState.auth.userId
        const user = rootState.users.items[userId]
        if (hasTaxNumberAndMoniker(user)) {
          dispatch('devices/loadCentralDevice', {}, { root: true })
            .then(device => {
              const apiData = {
                electronic_device: device.id,
                invoiceId: oldInvoice.id,
                oldFullNum: oldInvoice.invoiceFullNum,
                oldDate: oldInvoice.date,
                isReverseInvoice: true,
                comment,
                issuer: userId
              }
              dispatch('saveItem', { electronicDeviceId: device.id, apiData })
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        } else {
          showNoTaxNumberError()
          reject(new Error('No tax number'))
        }
      })
    },
    clearInvoices ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setElements', { type: 'items', elements: {} })
        resolve()
      })
    },
    getSequenceNumber ({ dispatch }, { deviceId }) {
      return new Promise((resolve, reject) => {
        dispatch('devices/getCurrentState', deviceId, { root: true })
          .then(response => {
            let currentNumber = response.data.items[0].last_invoice_number
            if (!currentNumber) currentNumber = 0
            resolve(currentNumber)
          })
          .catch(error => reject(error))
      })
    },
    getPdf ({ commit }, invoiceId) {
      return new Promise((resolve, reject) => {
        invoices.getPdf({ id: invoiceId, data: { print_type: 2 } })
          .then(response => {
            const pdfData = response.data.items[0]
            resolve(pdfData)
          })
          .catch(error => reject(error))
      })
    },
    getInvocesPdf ({ commit, rootState }, { dateFrom, dateTo, clientOnly, client = null, paymentType = null }) {
      return new Promise((resolve, reject) => {
        let businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        invoices.getInvoicesPdf({ businessUnitId, dateFrom, dateTo, clientOnly, client, paymentType })
          .then(response => {
            const pdfData = response.data.items[0]
            resolve(pdfData)
          })
          .catch(error => reject(error))
      })
    },
    getInvocesExcel ({ commit, rootState }, { dateFrom, dateTo, clientOnly, client = null, paymentType = null }) {
      return new Promise((resolve, reject) => {
        let businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        invoices.getInvoicesExcel({ businessUnitId, dateFrom, dateTo, clientOnly, client, paymentType })
          .then(response => {
            const excelData = response.data.items[0]
            resolve(excelData)
          })
          .catch(error => reject(error))
      })
    }
  },

  mutations: {
    ...mutations,
    updateInvoice (state, { invoiceId, updates }) {
      if (updates.payment_type) {
        Vue.set(state.items[invoiceId], 'payment_type', updates.payment_type)
        Vue.set(state.items[invoiceId], 'payment_type_name', updates.payment_type_name)
        Vue.set(state.items[invoiceId], 'print_payment_type', updates.print_payment_type)
      }
      if (updates.client) {
        Vue.set(state.items[invoiceId], 'client', updates.client)
        Vue.set(state.items[invoiceId], 'client_name', updates.client_name)
      }
      if (updates.payments) {
        Vue.set(state.items[invoiceId], 'payments', updates.payments)
      }
      if (updates.comment) {
        Vue.set(state.items[invoiceId], 'comment', updates.comment)
      }
      if (updates.invoice_id) {
        Vue.set(state.items[invoiceId], 'invoice_id', updates.invoice_id)
      }
    },
    setInvoicePrints (state, invoice) {
      const prints = []
      Vue.set(state.items[invoice.id], 'prints', prints)
    },
    addBuyerInfoToInvoice (state, { invoiceId, client }) {
      Vue.set(state.items[invoiceId], 'buyerInfo', client)
    }
  }
}

const dataForApi = (userId, updates, payments, comment, issuer) => {
  const data = {
    payment_type: updates.payment_type || null,
    client: updates.client || null
  }
  if (issuer) {
    data.issuer = issuer
  }
  if (updates.payment_type) {
    data.payment_type = updates.payment_type
  }
  // if (updates.client) {
  data.client = updates.client
  // }
  if (payments) {
    data.payments = payments
  }
  if (comment !== null) {
    data.comment = comment
  }
  return data
}

const showNoTaxNumberError = () => {
  new AWN({
    position: 'bottom-right',
    labels: {
      success: 'Akcija uspešna',
      warning: 'Opozorilo',
      alert: 'Napaka'
    }
  }).alert('Uporabnik potrebuje davčno številko in oznako blagajnika za izdajo računa.')
}

const hasTaxNumberAndMoniker = user => {
  return user.tax_number && (user.tax_number + '').length && user.moniker
}
